import styled from 'styled-components'

export const TNCWrapper = styled.div`
	padding: 10px;
	color: #ffffff;
`

export const CloseButtonWrapper = styled.div`
	text-align: center;
	position: sticky;
	bottom: 0px;
	background: var(--blackcurrant);
	padding: 5px;
`

export const CloseButton = styled.button`
	padding: 5px;
	border: 1px solid white;
	background: transparent;
	color: white;
	border-radius: 5px;
`

export const OL = styled.ol`
	font-size: 12px;
	text-align: justify;
	color: var(--placeholder-color);
`

export const Paragraph = styled.p`
	font-size: 12px;
	text-align: justify;
	color: var(--placeholder-color);
`

export const Heading = styled.h2`
	color: var(--btn-color);
	text-align: center;
	font-size: 14px;
`

export const Heading2 = styled.h2`
	color: var(--placeholder-color);
	font-size: 14px;
`

export const Table = styled.table`
	border-collapse: collapse;
	border-spacing: 0;
	width: 100%;
	margin-top: 15px;
	margin-bottom: 15px;
`

export const TH = styled.th`
	border: 1px solid var(--placeholder-color);
	color: var(--placeholder-color);
	font-size: 14px;
	font-weight: bold;
	padding: 10px 5px;
`

export const TD = styled.td`
	border: 1px solid var(--placeholder-color);
	color: var(--placeholder-color);
`
